// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root Styles */
h3, label {
 margin: 0;
}

.customization-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  border-radius: 20px;
  box-sizing: border-box;
  position: relative;
  max-width: 1500px;
  flex-direction: row;
  height: auto; /* Let it adjust naturally */
}

/* Options container can expand naturally */
.options-container {
  flex: 1 1;
  max-width: 45%;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
}

.warm-lead-parent-container {
  width: 100%;
  max-width: 1100px;
}

.warm-lead-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

/* Make preview-container extend to the bottom without overflowing */
.preview-container {
  display: flex;
  flex-direction: column;
  max-width: 55%;
  width: 100%;
  overflow: hidden;
  height: auto; /* Let aspect-ratio control height */
  aspect-ratio: 4 / 3.25;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
}


/* FIXED iframe */
.preview-container iframe {
  width: 100%;
  height: 100%;
  border: none;
  flex-grow: 1; /* Ensures iframe fills container properly */
}


/* Headings */
.options-container h3,
.preview-container h3,
.warm-lead-container h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 25px;
  color: #222;
}

/* Control Groups */
.control-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.control-group:last-child {
  margin-bottom: 0px;
}

.control-group label {
  font-size: 14px;
  font-weight: 500;
  color: #444;
}

.color-picker-container {
  display: flex;
  align-items: center;
}

.border-radius-container {
  display: flex;
  align-items: center;
}

.widget-setting-title {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 40%;
}

.alignment-icon {
  font-size: 20px;
  color: #5616ea;
}

/* Color Pickers */
.options-container input[type="color"] {
  border: 1px solid rgb(199, 199, 199);
  width: 34px;
  height: 34px;
  cursor: pointer;
  border-radius: 20%;
  padding: 1.5px;
  background: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  outline: none;
  background-color: transparent;
}

.options-container input[type="color"]:hover {
  transform: scale(1.1);
}

.options-container input[type="color"]::-webkit-color-swatch {
  border: none;
  border-radius: 20%;
}

/* File Upload Button */
.options-container input[type="file"] {
  display: none;
}

label.slider {
  width: 60%;
}

label.file-upload {
  width: 170px;
  display: inline-block;
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 5px;
  border: 1px solid #ddd;
  cursor: pointer;
  background-color: #ededed;
  text-align: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

label.file-upload:hover {
  background-color: #dedede;
  transform: translateY(-2px);
}

.upload-icon-text {
  display: flex;
  align-items: center;
  gap: 10px;
}

.upload-icon-text p {
  margin: 0;
  padding: 0;
}

.upload-with-tooltip {
  display: flex;
  align-items: center;
  gap: 4px;
}

.save-discard-buttons {
  display: flex;
  gap: 10px;
}

.save-widget-btn {
    padding: 8px 14px;
    padding-top: 7px;
    background-color: #5616ea;
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.2s ease;
}

.save-widget-btn:hover {
    background-color: #4a14d6;
    transform: translateY(-1px);
}

.save-widget-btn:disabled {
    background-color: #7d55ff;
    opacity: 0.6;
    cursor: not-allowed;
    transform: translateY(0);
}

.save-widget-btn:hover {
  background-color: #4a14d6;
  transform: translateY(-1px);
}

.save-widget-btn:disabled {
  background-color: #bbbbbb;
  transform: translateY(0px);
  cursor: not-allowed;
}

.discard-widget-btn {
  align-self: flex-start;
  font-size: 14px;
  font-weight: 500;
  color: black;
  border: 1px solid rgb(219, 219, 219);
  background-color: #ededed;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
  box-shadow: 0 4px 14px rgba(0,0,0,0.1);
}

.discard-widget-btn:hover {
  background-color: #e5e5e5;
  transform: translateY(-1px);
}

/* Checkbox */
.options-container input[type="checkbox"] {
  display: none;
}

label.checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding-left: 30px;
}

label.checkbox::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  border: 2px solid #5616ea;
  border-radius: 4px;
  background: transparent;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  box-sizing: border-box;
}

input[type="checkbox"]:checked + label.checkbox::before {
  background-color: #5616ea;
  border-color: #4a14d6;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}

input[type="checkbox"]:checked + label.checkbox {
  color: #4a14d6;
}

/* Range Sliders */
.options-container input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
  height: 6px;
  background: #ddd;
  border-radius: 3px;
  outline: none;
  margin-top: 5px;
  transition: background 0.3s ease;
}

.options-container input[type="range"]:hover {
  background: #ccc;
}

.options-container input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background: #5616ea;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  -webkit-transition: background-color 0.3s ease, transform 0.3s ease;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.options-container input[type="range"]::-webkit-slider-thumb:hover {
  background: #4a14d6;
  transform: scale(1.1);
}

.preview-container h3 {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #222;
}

/* Chat Window Mockup */
.preview-container .chat-window {
  border: none;
  border-radius: 15px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
}

.preview-container .chat-window:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 50px rgba(0,0,0,0.07);
}

/* Icon in Preview */
.preview-container .chat-widget-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.uploaded-file-info {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.uploaded-file-info span {
  margin-right: 8px;
  font-size: 14px;
  color: #333;
}

.remove-file-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #5616ea;
  font-size: 16px;
  padding: 2px 4px;
  transition: color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
  margin-right: 4px;
}

.remove-file-btn:hover {
  color: #4a14d6;
  transform: scale(1.15);
}

.unsaved-changes-message {
  display: flex;
  align-items: center;
  background-color: #f8e8d7;
  padding: 8px;
  border: 1px solid #f5d9b7;
  border-radius: 8px;
  font-size: 16px;
  gap: 5px;
  color: #000000;
  margin-top: 10px;
}

.warning-icon {
  font-size: 20px;
  line-height: 1;
}

.warning-text {
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
}

.radio-buttons {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 15px;
}

.radio-buttons-content {
  display: flex;
  align-items: center;
  margin: 10px 0;
  width: 80px;
}

.radio-buttons-content input[type="radio"] {
  display: none;
}

.radio-buttons-content label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding-left: 24px;
}

.radio-buttons-content label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  border: 1.5px solid #5616ea;
  border-radius: 4px; /* Rounded corners for a square shape */
  background: transparent;
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  box-sizing: border-box;
}

.radio-buttons-content input[type="radio"]:checked + label::before {
  background-color: #5616ea;
  border-color: #4a14d6;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
}

.radio-buttons-content input[type="radio"]:checked + label {
  color: #4a14d6;
}

.delay-seconds-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.delay-seconds-input {
  max-width: 150px !important;
}

/* Webflow agents: the hosted widget shows no attention pop-ups. */
.widget-pop-ups-webflow-note {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #6b7280;
}

.welcome-messages-parent {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.widget-sub-header {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  padding: 0;
  margin-bottom: 1rem;
  color: #5616ea;
}

/* Responsive */
@media (max-width: 768px) {
  .customization-container {
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .options-container, .preview-container {
    width: 100%;
    max-width: 600px;
    padding-left: 20px;
    padding-right: 20px;
  }

  label.slider {
    width: 80%;
  }

  label.file-upload {
    width: 70%;
  }

  .widget-setting-title {
    width: 50%;
  }

  .color-picker-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .preview-container {
    min-height: 500px !important;
    aspect-ratio: 3.5 / 7.5;
  }

  .widget-setting-title {
    font-weight: 600;
  }

  .radio-buttons {
    gap: 2px;
  }
}

@media (min-width: 769px) {
  .customization-container {
    align-items: flex-start;
  }

  .preview-container {
    position: sticky;
    /* Offset by the fixed app header height (+ a small gap) so the sticky
       preview parks just below the header instead of sliding under it and
       getting its "Preview" title / screenshot button clipped. */
    top: calc(var(--app-header-height, 56px) + 20px);
    align-self: flex-start;
    z-index: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/widgetCustomizationTab.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;CACC,SAAS;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY,EAAE,4BAA4B;AAC5C;;AAEA,2CAA2C;AAC3C;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY,EAAE,oCAAoC;EAClD,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;;AAGA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY,EAAE,4CAA4C;AAC5D;;;AAGA,aAAa;AACb;;;EAGE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qDAAqD;EACrD,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,2DAA2D;EAC3D,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,mEAA2D;EAA3D,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iFAAiF;EACjF,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB,EAAE,uCAAuC;EAC3D,uBAAuB;EACvB,oFAAoF;EACpF,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IAEE,gBAAgB;IAChB;;iEAE6D;IAC7D,gDAAgD;IAChD,sBAAsB;IACtB,UAAU;EACZ;AACF","sourcesContent":["/* Root Styles */\r\nh3, label {\r\n margin: 0;\r\n}\r\n\r\n.customization-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 20px;\r\n  border-radius: 20px;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  max-width: 1500px;\r\n  flex-direction: row;\r\n  height: auto; /* Let it adjust naturally */\r\n}\r\n\r\n/* Options container can expand naturally */\r\n.options-container {\r\n  flex: 1;\r\n  max-width: 45%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n}\r\n\r\n.warm-lead-parent-container {\r\n  width: 100%;\r\n  max-width: 1100px;\r\n}\r\n\r\n.warm-lead-container {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 20px;\r\n  padding: 20px;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.05);\r\n}\r\n\r\n/* Make preview-container extend to the bottom without overflowing */\r\n.preview-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-width: 55%;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  height: auto; /* Let aspect-ratio control height */\r\n  aspect-ratio: 4 / 3.25;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n}\r\n\r\n\r\n/* FIXED iframe */\r\n.preview-container iframe {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none;\r\n  flex-grow: 1; /* Ensures iframe fills container properly */\r\n}\r\n\r\n\r\n/* Headings */\r\n.options-container h3,\r\n.preview-container h3,\r\n.warm-lead-container h3 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 25px;\r\n  color: #222;\r\n}\r\n\r\n/* Control Groups */\r\n.control-group {\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n}\r\n\r\n.control-group:last-child {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.control-group label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #444;\r\n}\r\n\r\n.color-picker-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.border-radius-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.widget-setting-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 40%;\r\n}\r\n\r\n.alignment-icon {\r\n  font-size: 20px;\r\n  color: #5616ea;\r\n}\r\n\r\n/* Color Pickers */\r\n.options-container input[type=\"color\"] {\r\n  border: 1px solid rgb(199, 199, 199);\r\n  width: 34px;\r\n  height: 34px;\r\n  cursor: pointer;\r\n  border-radius: 20%;\r\n  padding: 1.5px;\r\n  background: none;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  outline: none;\r\n  background-color: transparent;\r\n}\r\n\r\n.options-container input[type=\"color\"]:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.options-container input[type=\"color\"]::-webkit-color-swatch {\r\n  border: none;\r\n  border-radius: 20%;\r\n}\r\n\r\n/* File Upload Button */\r\n.options-container input[type=\"file\"] {\r\n  display: none;\r\n}\r\n\r\nlabel.slider {\r\n  width: 60%;\r\n}\r\n\r\nlabel.file-upload {\r\n  width: 170px;\r\n  display: inline-block;\r\n  padding: 10px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  border-radius: 5px;\r\n  border: 1px solid #ddd;\r\n  cursor: pointer;\r\n  background-color: #ededed;\r\n  text-align: center;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\nlabel.file-upload:hover {\r\n  background-color: #dedede;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.upload-icon-text {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.upload-icon-text p {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.upload-with-tooltip {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.save-discard-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.save-widget-btn {\r\n    padding: 8px 14px;\r\n    padding-top: 7px;\r\n    background-color: #5616ea;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 10px;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.save-widget-btn:hover {\r\n    background-color: #4a14d6;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.save-widget-btn:disabled {\r\n    background-color: #7d55ff;\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n    transform: translateY(0);\r\n}\r\n\r\n.save-widget-btn:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.save-widget-btn:disabled {\r\n  background-color: #bbbbbb;\r\n  transform: translateY(0px);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.discard-widget-btn {\r\n  align-self: flex-start;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: black;\r\n  border: 1px solid rgb(219, 219, 219);\r\n  background-color: #ededed;\r\n  padding: 10px 20px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n  box-shadow: 0 4px 14px rgba(0,0,0,0.1);\r\n}\r\n\r\n.discard-widget-btn:hover {\r\n  background-color: #e5e5e5;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Checkbox */\r\n.options-container input[type=\"checkbox\"] {\r\n  display: none;\r\n}\r\n\r\nlabel.checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #444;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  position: relative;\r\n  padding-left: 30px;\r\n}\r\n\r\nlabel.checkbox::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 18px;\r\n  height: 18px;\r\n  border: 2px solid #5616ea;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  transition: background-color 0.3s ease, border-color 0.3s ease;\r\n  box-sizing: border-box;\r\n}\r\n\r\ninput[type=\"checkbox\"]:checked + label.checkbox::before {\r\n  background-color: #5616ea;\r\n  border-color: #4a14d6;\r\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\ninput[type=\"checkbox\"]:checked + label.checkbox {\r\n  color: #4a14d6;\r\n}\r\n\r\n/* Range Sliders */\r\n.options-container input[type=\"range\"] {\r\n  -webkit-appearance: none;\r\n  width: 100%;\r\n  height: 6px;\r\n  background: #ddd;\r\n  border-radius: 3px;\r\n  outline: none;\r\n  margin-top: 5px;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.options-container input[type=\"range\"]:hover {\r\n  background: #ccc;\r\n}\r\n\r\n.options-container input[type=\"range\"]::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 16px;\r\n  height: 16px;\r\n  background: #5616ea;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.options-container input[type=\"range\"]::-webkit-slider-thumb:hover {\r\n  background: #4a14d6;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.preview-container h3 {\r\n  margin-bottom: 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #222;\r\n}\r\n\r\n/* Chat Window Mockup */\r\n.preview-container .chat-window {\r\n  border: none;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  background: #ffffff;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.05);\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  position: relative;\r\n}\r\n\r\n.preview-container .chat-window:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 20px 50px rgba(0,0,0,0.07);\r\n}\r\n\r\n/* Icon in Preview */\r\n.preview-container .chat-widget-icon {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.uploaded-file-info {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-top: 8px;\r\n}\r\n\r\n.uploaded-file-info span {\r\n  margin-right: 8px;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.remove-file-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #5616ea;\r\n  font-size: 16px;\r\n  padding: 2px 4px;\r\n  transition: color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n  margin-right: 4px;\r\n}\r\n\r\n.remove-file-btn:hover {\r\n  color: #4a14d6;\r\n  transform: scale(1.15);\r\n}\r\n\r\n.unsaved-changes-message {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #f8e8d7;\r\n  padding: 8px;\r\n  border: 1px solid #f5d9b7;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  gap: 5px;\r\n  color: #000000;\r\n  margin-top: 10px;\r\n}\r\n\r\n.warning-icon {\r\n  font-size: 20px;\r\n  line-height: 1;\r\n}\r\n\r\n.warning-text {\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  margin: 0;\r\n}\r\n\r\n.radio-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n  text-align: center;\r\n  justify-content: center;\r\n  gap: 15px;\r\n}\r\n\r\n.radio-buttons-content {\r\n  display: flex;\r\n  align-items: center;\r\n  margin: 10px 0;\r\n  width: 80px;\r\n}\r\n\r\n.radio-buttons-content input[type=\"radio\"] {\r\n  display: none;\r\n}\r\n\r\n.radio-buttons-content label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #444;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  position: relative;\r\n  padding-left: 24px;\r\n}\r\n\r\n.radio-buttons-content label::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 18px;\r\n  height: 18px;\r\n  border: 1.5px solid #5616ea;\r\n  border-radius: 4px; /* Rounded corners for a square shape */\r\n  background: transparent;\r\n  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.radio-buttons-content input[type=\"radio\"]:checked + label::before {\r\n  background-color: #5616ea;\r\n  border-color: #4a14d6;\r\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.radio-buttons-content input[type=\"radio\"]:checked + label {\r\n  color: #4a14d6;\r\n}\r\n\r\n.delay-seconds-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.delay-seconds-input {\r\n  max-width: 150px !important;\r\n}\r\n\r\n/* Webflow agents: the hosted widget shows no attention pop-ups. */\r\n.widget-pop-ups-webflow-note {\r\n  margin: 8px 0 0;\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n  color: #6b7280;\r\n}\r\n\r\n.welcome-messages-parent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.widget-sub-header {\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  margin: 0;\r\n  padding: 0;\r\n  margin-bottom: 1rem;\r\n  color: #5616ea;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .customization-container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 30px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n  }\r\n\r\n  .options-container, .preview-container {\r\n    width: 100%;\r\n    max-width: 600px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n  }\r\n\r\n  label.slider {\r\n    width: 80%;\r\n  }\r\n\r\n  label.file-upload {\r\n    width: 70%;\r\n  }\r\n\r\n  .widget-setting-title {\r\n    width: 50%;\r\n  }\r\n\r\n  .color-picker-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .preview-container {\r\n    min-height: 500px !important;\r\n    aspect-ratio: 3.5 / 7.5;\r\n  }\r\n\r\n  .widget-setting-title {\r\n    font-weight: 600;\r\n  }\r\n\r\n  .radio-buttons {\r\n    gap: 2px;\r\n  }\r\n}\r\n\r\n@media (min-width: 769px) {\r\n  .customization-container {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .preview-container {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    /* Offset by the fixed app header height (+ a small gap) so the sticky\r\n       preview parks just below the header instead of sliding under it and\r\n       getting its \"Preview\" title / screenshot button clipped. */\r\n    top: calc(var(--app-header-height, 56px) + 20px);\r\n    align-self: flex-start;\r\n    z-index: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
